// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container_NJyKo.override_S0kQX {
  border : none;
  padding: 16px 16px;
}`, "",{"version":3,"sources":["webpack://./src/editors/values/ParentRelationshipEditor.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,kBAAkB;AACpB","sourcesContent":[".container.override {\n  border : none;\n  padding: 16px 16px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `container_NJyKo`,
	"override": `override_S0kQX`
};
export default ___CSS_LOADER_EXPORT___;
